import React, { useState, useEffect } from 'react';
import { Typography, Box, IconButton } from '@mui/material';
import './css/special.camp.css';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DashboardHeader from '../../header/DashboardHeader';
import { specialCampViewModel } from './special.camp.viewmodel';
import { useHistory } from 'react-router-dom';
import SpecialCampCard from './SpecialCampCard';

const SpecialCampList = () => {
  const history = useHistory();
  const { dependent } = history?.location?.state || '';
  const [specialCampList, setSpecialCampList] = useState([]);
  const [dependentSpecialCamps, setDependentSpecialCamps] = useState([]);

  const getMultiSpecialCamp = () => {
    if (dependent) {
      let campId = dependent?.school_details?.id ?? 0;
      specialCampViewModel
        .getGuardianMultiSpecialCamps(campId, dependent?.id)
        .then((res) => {
          console.log(res);
          setSpecialCampList(res);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const getSpecialCamps = () => {
    specialCampViewModel
      .getDependentMultiSpecialCamps(dependent?.id)
      .then((res) => {
        setDependentSpecialCamps(res);
      })
      .catch((err) => { });
  };

  useEffect(() => {
    if (dependent?.id) {
      getSpecialCamps();
    }
  }, [dependent]);

  useEffect(() => {
    getMultiSpecialCamp();
  }, []);

  return (
    <>
      <DashboardHeader />
      {/* Main Container */}
      <Box
        sx={{
          maxWidth: 'md',
          margin: 'auto',
          textAlign: 'center',
          mt: 4,
          mb: 4,
        }}
        className="box_backgroung_SPcamp"
      >
        {/* Back Arrow and Title */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 3.5,
          }}
        >
          <IconButton
            onClick={() => history.goBack()}
            sx={{ position: 'absolute', left: '16px' }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography
            variant="h4"
            sx={{ fontSize: '38px', fontWeight: '800', lineHeight: '43.58px' }}
          >
            Dream Camps for {dependent?.username}
          </Typography>
        </Box>
        {/* Card Section */}
        {specialCampList.length > 0 ? (
          specialCampList.map((item, key) => (
            <Box key={key}>
              <SpecialCampCard
                camp={item}
                dependent={dependent}
                dependentSpecialCamps={dependentSpecialCamps}
              />
            </Box>
          ))
        ) : (
          <Typography variant="h3">No Dream Camps Available</Typography>
        )}
      </Box>
    </>
  );
};

export default SpecialCampList;
